/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Carousel, Col, Divider, Empty, List, Row, Typography } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../../layouts/User";
import styles from "./index.module.scss";

moment.locale("th");

const { Text, Paragraph } = Typography;

const Promotions: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const isFetchedUser = useSelector((state: any) => state.isFetchedUser);
  const [feedData, setFeedData] = useState<any>([]);

  const getFeed = async () => {
    if (user._id) {
      const { data } = await axios.get(`/broadcasts/feeds/${user._id}`);
      setFeedData(data.data);
    } else {
      await getFeedWithoutLogin();
    }
  };

  const getFeedWithoutLogin = async () => {
    const { data } = await axios.get('/broadcasts/feeds/withoutlogin');
    setFeedData(data.data);
  }

  const dateFormat = (datetime: any) => {
    const formatted = moment(new Date(datetime)).format("DD/MM/YYYY");
    return formatted;
  };

  useEffect(() => {
    if (isFetchedUser) {
      getFeed();
    }
  }, [isFetchedUser]);

  const feedBroadcast = (
    <div>
      <List
        itemLayout={"vertical"}
        locale={{
          emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="เตรียมพบโปรโมชั่นเร็วๆนี้"/>
        }}
        dataSource={feedData}
        renderItem={(item: any) => (
          <List.Item>
            <Card
              style={{ width: "100%" }}
              bodyStyle={{ padding: "0 0 10px 0" }}
            >
              <Carousel autoplay autoplaySpeed={5000}>
                {item.broadcastImages.map((value: any, index: any) => {
                  return (
                    <a href={item.redirectUrl} key={index}>
                      <img
                        style={{ width: "100%" }}
                        src={value.url}
                        alt=""
                      />
                    </a>
                  );
                })}
              </Carousel>
              <Paragraph
                ellipsis={{ rows: 2, expandable: true, symbol: "เพิ่มเติม" }}
                className={styles.antTypographyExpand}
              >
                {item.message}
              </Paragraph>
              <Text italic type="secondary" className={styles.antTextSecondary}>
                {dateFormat(item.updatedAt)}
              </Text>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );

  return (
    <>
      <Layout>
        <div className={styles.header}>
          <Link to="/" className={styles.buttonLink}><Text>หน้าแรก</Text></Link>
          <Text strong className={`${styles.buttonLink} ${styles.active}`}>โปรโมชั่นสำหรับคุณ</Text>
        </div>
        <Divider className={styles.divider} />

        <Row>
          <Col xs={{ span: 24 }} md={{ span: 16, offset: 4 }}>
            {feedBroadcast}
          </Col>
        </Row>
      </Layout>
    </>
  );
};

export default Promotions;
